import React from "react";
import PropTypes from "prop-types";
import GlobalsContext from "../context/GlobalsContext";

const IfPermission = ({ children, checker }) => {
  const globalsContext = React.useContext(GlobalsContext);

  if (checker(globalsContext.permissions, globalsContext.user)) {
    return children;
  }

  return null;
};

IfPermission.propTypes = {
  checker: PropTypes.func.isRequired
};

export default IfPermission;
